import _pt from "prop-types";
import * as React from 'react';
import { usePkpass } from '../usePkpass';
import { PkpassFieldsType } from '../../../../types';
import Field from './field/preview/Field';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../Theme';
const useStyles = createUseStyles({
  fields: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: ({
      fieldsType
    }) => fieldsType === PkpassFieldsType.HeaderFields ? 'flex-end' : 'space-between',
    minHeight: ({
      theme
    }) => theme.scale * 40,
    paddingBottom: ({
      theme
    }) => theme.scale * 10,
    // direction: ({ fieldsType }) =>
    //   fieldsType === PkpassFieldsType.HeaderFields ? 'rtl' : undefined,
    width: ({
      fieldsType
    }) => fieldsType === PkpassFieldsType.PrimaryFields ? '100%' : undefined
  }
});

const Fields = props => {
  const {
    passStyle,
    pass,
    onFieldDnD
  } = usePkpass();
  const {
    fieldsType
  } = props;
  const [dragOver, setDragOver] = React.useState(false);

  const onDragOver = event => {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(true);
  };

  const onDragLeave = event => {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(false);
  };

  const onDrop = event => {
    event.preventDefault();
    event.stopPropagation();
    const droppedIndex = Number(event.dataTransfer.getData('droppedIndex'));
    const droppedFieldsType = event.dataTransfer.getData('droppedFieldsType');
    onFieldDnD(fieldsType, 0, droppedFieldsType, droppedIndex);
    setDragOver(false);
  };

  const theme = useTheme();
  const classes = useStyles({
    theme,
    fieldsType,
    dragOver
  });
  let fields = pass[passStyle][fieldsType] || [];

  if (fieldsType === PkpassFieldsType.HeaderFields) {
    fields = fields.reverse();
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.fields,
    onDrop: onFieldDnD ? onDrop : undefined,
    onDragOver: onFieldDnD ? onDragOver : undefined,
    onDragLeave: onFieldDnD ? onDragLeave : undefined,
    style: dragOver ? theme.dragOver : undefined
  }, fields.map((field, i) => {
    const index = fieldsType === PkpassFieldsType.HeaderFields ? fields.length - i - 1 : i;
    return /*#__PURE__*/React.createElement(Field, {
      key: field.key,
      fieldsType: fieldsType,
      fieldIndex: index
    });
  }));
};

export default Fields;
//# sourceMappingURL=Fields.js.map